import { useOperation } from "@hooks";
import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";

export default function ActionMenuOperationItem(props) {
  const {
    label,
    operation,
  } = props;

  const enqueueOperation = useOperation({
    key: operation.key,
    args: operation.args,
    callback: operation.callback,
    enqueueDelay: operation.enqueueDelay,
  });

  const handleClick = (event) => {
    event.keepOpen = true;

    if (window.confirm(`Are you sure you want to execute: ${label?.text}?`)) {
      enqueueOperation();
    }
  };

  /**************************************************************************************************/

  return (
    <ActionMenuBaseItem
      onClick={handleClick}
      {...props}
    />
  );
}
